import aspida from '@aspida/axios'

import api from '@/api/$api'
import { axios } from '@/lib/axios'

export const aspidaClient = api(aspida(axios))
